import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import { FaBars, FaSun, FaMoon } from "react-icons/fa";
import { BiDownArrow } from "react-icons/bi";
import "./Header.css";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Colour, FilterMain, JobExecData, MainFilter, FirmAndUser } from "../../Redux/Slice/login/loginSlice";
import { IoMdRefresh } from "react-icons/io";
import { ClipLoader } from "react-spinners";
import { Building2, Calendar, Check, Sliders, Clock, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useTheme } from "../../Themecontext/Themecontext";


const Header = ({ toggleSidebar }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const firm = Cookies.get('Firm')
  const FinancialYear = Cookies.get('FinancialYear')

  const { Colourdata, mainFilterData, DataMain, JobExecDatas, JobLoading, filterData } = useSelector((state) => state.ClientLogin);

  const displayFirms = Cookies.get("Role") === "millstageuser" && filterData?.Firm_List?.length > 0
    ? filterData.Firm_List
    : DataMain?.Firm_List;

  const getActiveThemeName = () => {
    const path = window.location.pathname;

    // FAS Paths
    const fasPaths = [
      "/Ledger", "/TrialBalance", "/ProfitAndLoss", "/BalanceSheet", "/FundAndFlow",
      "/Receivable", "/Payable", "/Customer", "/Supplier", "/Bank",
      "/SaleDashboard", "/MonthWisePartyWiseSale", "/PartyWiseItemWiseSale",
      "/ProductionGroupWise", "/ItemWiseMonthWise", "/ItemWiseSummary",
      "/PartyItemWiseSummary", "/MonthItemParty", "/PartyWiseQuarter",
      "/PurchaseDashboard", "/MonthWisePartyWisePurchase", "/PartyWiseItemWisePurchase",
      "/MonthWiseBookWise", "/BookWise", "/BookWiseSubBookWise",
      "/BookWiseMonthlyAnylysis", "/Gstr", "/Tds"
    ];
    if (fasPaths.some(p => path.startsWith(p))) {
      return { light: "NEWFAS", dark: "NEWFASDARK" };
    }

    // Colour Paths
    const colourPaths = [
      "/InwardAnalysis", "/MachineGroupWiseCosting", "/MasterWiseMachineGroupCosting",
      "/MachineGroupWithMachineCosting", "/MachineGroupCostingSummary",
      "/MasterWiseMonthlyConsumption", "/MachineGroupCostAnlysis",
      "/MachineGroupBatchCosting", "/MasterWiseConsumption", "/MasterWiseCosting",
      "/Abc", "/Fsn", "/Stock", "/MonthlyStock", "/ItemSupplierAnaylysis",
      "/PartyItemAnalysis"
    ];
    if (colourPaths.some(p => path.startsWith(p))) {
      return { light: "NEWCOLOURCHEMICL", dark: "NEWCOLOURCHEMICLDARK" };
    }

    // Maintenance Paths
    const maintenancePaths = [
      "/InwardAnalysism", "/InwardItemWise", "/IssueItemWise",
      "/ItemWiseMachineWiseConsumption", "/MachineMachineGroupWiseConsumtion",
      "/MachineWiseConsumption", "/MachineGroupWiseConsumtion",
      "/MachineGroupMonthWiseConsumption", "/itemWiseDailyAndMonthly",
      "/FsnAnalysis", "/StockAnalysis", "/AbcAnalysis", "/PartyItemAnalysisMain",
      "/ItemSupplierAnaylysisMain"
    ];
    if (maintenancePaths.some(p => path.startsWith(p))) {
      return { light: "MAINTENANCE", dark: "MAINTENANCEDARK" };
    }

    // Payroll Paths
    const payrollPaths = [
      "/SalaryAnalysisDashboard", "/SalaryStatement", "/DepWiseSalarySummary",
      "/EmployeeProfile", "/SalarySummary", "/PTStatement", "/ESIStatement",
      "/PFStatement", "/ESI_PF_PT_Summary", "/DepartmentWisePresent"
    ];
    if (payrollPaths.some(p => path.startsWith(p))) {
      return { light: "PAYROLL", dark: "PAYROLLDARK" };
    }

    // Millstage Paths
    const millstagePaths = [
      "/ProcessMaster", "/ProcessQuality", "/SubProcess", "/ShadeMaster", "/QualityMaster", "/TransProcessType"
    ];
    if (millstagePaths.some(p => path.startsWith(p))) {
      return { light: "NEWMILLSTAGE", dark: "NEWMILLSTAGEDARK" };
    }

    // Default to Grey
    return { light: "GRAYNEW", dark: "GRAYDARKNEW" };
  };

  const activeTheme = getActiveThemeName();
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === activeTheme.light);
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === activeTheme.dark
  );

  const { theme, setTheme } = useTheme();
  const isdark = theme;

  const [showDropdown, setShowDropdown] = useState(false);

  const [selectedFirmIds, setSelectedFirmIds] = useState(null);
  const [selectedFYIds, setSelectedFYIds] = useState(null);

  const [isHover, setIsHover] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const toggleSelection = (item, setIds) => {
    setIds(item.id);
  };

  const getDropdownLabel = () => {
    const activeFirmObj = displayFirms?.find(
      (f) => f.DashboardFirmID === Number(Cookies.get("Firm"))
    );
    const activeFYObj = DataMain?.AC_Year_List?.find(
      (fy) => fy.AcYearID === Number(Cookies.get("FinancialYear"))
    );

    if (activeFirmObj && activeFYObj) {
      let shortFY = activeFYObj.AcYear;
      const parts = activeFYObj.AcYear.split(" - ");
      if (parts.length === 2) {
        const startParts = parts[0].split("/");
        const endParts = parts[1].split("/");
        if (startParts.length === 3 && endParts.length === 3) {
          const startYear = startParts[2];
          const endYear = endParts[2];
          shortFY = `${startYear}-${endYear}`;
        }
      }

      const maxFirmLength = 25;
      const shortFirm = activeFirmObj.GroupName.length > maxFirmLength
        ? `${activeFirmObj.GroupName.substring(0, maxFirmLength)}...`
        : activeFirmObj.GroupName;

      return `${shortFirm} | ${shortFY}`;
    }

    return "Select Firm and Year";
  };

  const getDropdownTooltip = () => {
    const activeFirmObj = displayFirms?.find(
      (f) => f.DashboardFirmID === Number(Cookies.get("Firm"))
    );
    const activeFYObj = DataMain?.AC_Year_List?.find(
      (fy) => fy.AcYearID === Number(Cookies.get("FinancialYear"))
    );
    if (activeFirmObj && activeFYObj) {
      return `${activeFirmObj.GroupName} | ${activeFYObj.AcYear}`;
    }
    return "Select Firm and Year";
  };

  useEffect(() => {
    if (!Colourdata) {
      dispatch(Colour())
    }
  }, [dispatch, Colourdata])

  useEffect(() => {
    if (!mainFilterData) {
      dispatch(FilterMain({
        FirmIDs: firm,
        AcYearIDs: FinancialYear,
      }));
    }

    if (!DataMain) {
      dispatch(MainFilter({}));
    }

    if (Cookies.get("Role") === "millstageuser" && !filterData?.Firm_List) {
      dispatch(FirmAndUser({ MSDBName: Cookies.get("YearDatabase"), token: Cookies.get("authToken") }));
    }

    if (!JobExecDatas) {
      dispatch(JobExecData({}))
    }

  }, [DataMain, dispatch, firm, FinancialYear, JobExecDatas, mainFilterData]);


  const refresh = (() => {
    dispatch(JobExecData({}))
  })

  const logout = () => {
    const cookiesToRemove = [
      "authToken",
      "Firm",
      "FinancialYear",
      "FillterFirm",
      "FillterFinancialYear",
      "Database",
      "SqlId",
      "SqlName",
      "OwnerName",
      "Role",
    ];

    cookiesToRemove.forEach((cookie) => Cookies.remove(cookie));
    localStorage.clear();
    sessionStorage.clear();
    navigate("/", { replace: true });
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  const handleApplyAllFilters = () => {
    const selectedFirmObj = displayFirms?.find(
      (f) => f.DashboardFirmID === selectedFirmIds
    );
    const databaseName = selectedFirmObj?.databasename || null;

    const selectedFYObj = DataMain?.AC_Year_List?.find(
      (fy) => fy.AcYearID === selectedFYIds
    );
    const msdbName = selectedFYObj?.MSDBName || null;

    if (selectedFirmIds) {
      Cookies.set("Firm", selectedFirmIds, { expires: 7 });
    }

    if (databaseName) {
      Cookies.set("Database", databaseName, { expires: 7 });
    }

    if (selectedFYIds) {
      Cookies.set("FinancialYear", selectedFYIds, { expires: 7 });
      Cookies.set("YearDatabase", msdbName, { expires: 7 });
    }

    setShowDropdown(false);

    window.location.reload();
  };

  useEffect(() => {
    const firm = Cookies.get("Firm");
    const fy = Cookies.get("FinancialYear");

    setSelectedFirmIds(firm ? Number(firm) : null);
    setSelectedFYIds(fy ? Number(fy) : null);

  }, [DataMain]);


  const dropdownRef = useRef(null);
  const profileDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const changeTheme = (mode) => {
    setTheme(mode);
  };


  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
  }, [theme]);

  const formatDateTime = (value) => {
    if (!value) return "";

    // 👉 Only Time (HH:mm:ss)
    if (/^\d{2}:\d{2}(:\d{2})?$/.test(value)) {
      const [h, m] = value.split(":");
      let hours = Number(h);

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      return `${hours}:${m} ${ampm}`;
    }

    const [datePart, timePart] = value.split("T");

    if (!datePart) return value;

    const [year, month, day] = datePart.split("-");

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    let formattedDate = `${day} ${months[Number(month) - 1]} ${year}`;

    if (timePart) {
      const [h, m] = timePart.split(":");
      let hours = Number(h);

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      return `${formattedDate}, ${hours}:${m} ${ampm}`;

    }

    return formattedDate;
  };

  const [isSmall, setIsSmall] = useState(window.innerWidth <= 992);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  useEffect(() => {
    const handleResize = () => {
      setIsSmall(window.innerWidth <= 992);
      setIsMobile(window.innerWidth <= 576);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (

    <>


      <div
        className="px-3 py-2"
        style={{
          background: isdark === "light" ? "#ffffff" : "#020617",
          borderBottom: "1px solid #e5e7eb"
        }}
      >
        <Row className="align-items-center justify-content-between flex-nowrap m-0 w-100" style={{ gap: "8px" }}>

          {/* Menu Button */}
          <Col xs="auto" className="order-1 p-0 flex-shrink-0">

            <div
              onClick={toggleSidebar}
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
              className="d-flex align-items-center justify-content-center"
              style={{
                width: "40px",
                height: "40px",
                background: isHover
                  ? (isdark === "light" ? "#F1F5F9" : "#0F172A")
                  : "transparent",
                color: isdark === "light" ? "#000000" : "#ffffff",
                cursor: "pointer",
                borderRadius: "8px",
                transition: "0.2s"
              }}
            >
              <FaBars size={isSmall ? 17 : 20} />
            </div>

          </Col>

          {/* Financial Year Dropdown */}
          <Col className="order-2 d-flex justify-content-start px-0 flex-grow-1" style={{ minWidth: 0 }}>
            <div ref={dropdownRef} style={{ position: "relative", width: "max-content", maxWidth: isMobile ? "180px" : "400px", marginLeft: isMobile ? "5px" : "10px" }}>

              {/* Top Button */}
              <div
                onClick={() => setShowDropdown(!showDropdown)}
                title={getDropdownTooltip()}
                style={{
                  background: isdark === "light"
                    ? `#18569815`
                    : `${iscolourDark?.Colour10 || "#3b82f6"}20`,
                  border: `1px solid ${isdark === "light"
                    ? `#18569830`
                    : `${iscolourDark?.Colour10 || "#3b82f6"}30`}`,
                  color: isdark === "light"
                    ? "#185698"
                    : "#E2E8F0",
                  padding: isMobile ? "0 8px" : "0 15px",
                  borderRadius: "14px",
                  fontWeight: "700",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  height: isMobile ? "32px" : "38px"
                }}
              >
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                    fontSize: isMobile ? "11.5px" : "13.5px",
                    flex: 1,
                    textAlign: "left"
                  }}
                >
                  {getDropdownLabel()}
                </span>

                <span
                  style={{
                    transition: "0.3s",
                    transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                    marginLeft: isMobile ? "5px" : "10px"
                  }}
                >
                  <BiDownArrow size={isMobile ? 12 : undefined} />
                </span>
              </div>

              {/* Dropdown */}
              {showDropdown && (
                <div
                  style={{
                    position: "absolute",
                    top: "115%",
                    left: "0",
                    width: "300px",
                    maxWidth: "90vw",
                    background: isdark === "light" ? "#ffffff" : "#0f172a",
                    borderRadius: "20px",
                    padding: "20px",
                    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                    border: `1px solid ${isdark === "light" ? "#e2e8f0" : "#1f2937"}`,
                    zIndex: 1000
                  }}
                >
                  {/* Firm Section */}
                  <div style={{ marginBottom: "16px" }}>
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontWeight: "750",
                      textTransform: "uppercase",
                      letterSpacing: "0.07em",
                      marginBottom: "10px",
                      fontSize: "11px",
                      color: isdark === "light" ? "#1e293b" : "#f1f5f9",
                      paddingLeft: "4px"
                    }}>
                      <span style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: isdark === "light" ? "#185698" : (iscolourDark?.Colour10 || "#3b82f6"),
                        display: "inline-block"
                      }} />
                      Select Firm
                    </div>

                      <div
                        className="sidebar-scroller"
                        style={{
                          maxHeight: "150px",
                          overflowY: "auto",
                          borderRadius: "12px",
                          padding: "4px"
                        }}
                      >
                        {displayFirms?.map((firm, index) => {
                          const isSelected = String(selectedFirmIds) === String(firm?.DashboardFirmID);
                        return (
                          <div
                            key={index}
                            onClick={() =>
                              toggleSelection(
                                { id: firm?.DashboardFirmID, name: firm?.GroupName },
                                setSelectedFirmIds
                              )
                            }
                            title={firm?.GroupName}
                            className="dropdown-filter-item"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "10px 14px",
                              borderRadius: "12px",
                              cursor: "pointer",
                              transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                              background: isSelected
                                ? (isdark === "light" ? `#18569810` : `${iscolourDark?.Colour10 || "#3b82f6"}20`)
                                : "transparent",
                              color: isSelected
                                ? (isdark === "light" ? "#185698" : "#E2E8F0")
                                : (isdark === "light" ? "#475569" : "#cbd5e1"),
                              border: `1.5px solid ${isSelected
                                ? (isdark === "light" ? "#185698" : (iscolourDark?.Colour10 || "#3b82f6"))
                                : (isdark === "light" ? "#f1f5f9" : "#1e293b")
                                }`,
                              marginBottom: "8px"
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateX(2px)";
                              if (!isSelected) {
                                e.currentTarget.style.background = isdark === "light" ? "#f8fafc" : "rgba(255,255,255,0.02)";
                                e.currentTarget.style.borderColor = isdark === "light" ? "#cbd5e1" : "#334155";
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateX(0)";
                              if (!isSelected) {
                                e.currentTarget.style.background = "transparent";
                                e.currentTarget.style.borderColor = isdark === "light" ? "#f1f5f9" : "#1e293b";
                              }
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, minWidth: 0 }}>
                              <Building2 size={15} style={{ color: isSelected ? undefined : (isdark === "light" ? "#94a3b8" : "#475569"), flexShrink: 0 }} />
                              <span
                                className="dropdown-filter-item-text"
                                style={{
                                  fontSize: "13px",
                                  fontWeight: isSelected ? "600" : "500",
                                }}
                              >
                                {firm?.GroupName}
                              </span>
                            </div>
                            {isSelected && <Check size={16} style={{ flexShrink: 0, marginLeft: "8px" }} />}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Year Section */}
                  <div style={{ marginBottom: "18px" }}>
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontWeight: "750",
                      textTransform: "uppercase",
                      letterSpacing: "0.07em",
                      marginBottom: "10px",
                      fontSize: "11px",
                      color: isdark === "light" ? "#1e293b" : "#f1f5f9",
                      paddingLeft: "4px"
                    }}>
                      <span style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: isdark === "light" ? "#185698" : (iscolourDark?.Colour10 || "#3b82f6"),
                        display: "inline-block"
                      }} />
                      Select Financial Year
                    </div>

                    <div
                      className="sidebar-scroller"
                      style={{
                        maxHeight: "150px",
                        overflowY: "auto",
                        borderRadius: "12px",
                        padding: "4px"
                      }}
                    >
                      {DataMain?.AC_Year_List?.map((fy, index) => {
                        const isSelected = String(selectedFYIds) === String(fy?.AcYearID);
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              toggleSelection(
                                { id: fy?.AcYearID, name: fy?.AcYear },
                                setSelectedFYIds
                              )
                              if (Cookies.get("Role") === "millstageuser") {
                                dispatch(FirmAndUser({ MSDBName: fy?.MSDBName, token: Cookies.get("authToken") }));
                              }
                            }}
                            title={fy?.AcYear}
                            className="dropdown-filter-item"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "10px 14px",
                              borderRadius: "12px",
                              cursor: "pointer",
                              transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                              background: isSelected
                                ? (isdark === "light" ? `#18569810` : `${iscolourDark?.Colour10 || "#3b82f6"}20`)
                                : "transparent",
                              color: isSelected
                                ? (isdark === "light" ? "#185698" : "#E2E8F0")
                                : (isdark === "light" ? "#475569" : "#cbd5e1"),
                              border: `1.5px solid ${isSelected
                                ? (isdark === "light" ? "#185698" : (iscolourDark?.Colour10 || "#3b82f6"))
                                : (isdark === "light" ? "#f1f5f9" : "#1e293b")
                                }`,
                              marginBottom: "8px"
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateX(2px)";
                              if (!isSelected) {
                                e.currentTarget.style.background = isdark === "light" ? "#f8fafc" : "rgba(255,255,255,0.02)";
                                e.currentTarget.style.borderColor = isdark === "light" ? "#cbd5e1" : "#334155";
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateX(0)";
                              if (!isSelected) {
                                e.currentTarget.style.background = "transparent";
                                e.currentTarget.style.borderColor = isdark === "light" ? "#f1f5f9" : "#1e293b";
                              }
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, minWidth: 0 }}>
                              <Calendar size={15} style={{ color: isSelected ? undefined : (isdark === "light" ? "#94a3b8" : "#475569"), flexShrink: 0 }} />
                              <span
                                className="dropdown-filter-item-text"
                                style={{
                                  fontWeight: isSelected ? "600" : "500",
                                }}
                              >
                                {fy?.AcYear}
                              </span>
                            </div>
                            {isSelected && <Check size={16} style={{ flexShrink: 0, marginLeft: "8px" }} />}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Apply Button */}
                  <button
                    onClick={handleApplyAllFilters}
                    style={{
                      width: "100%",
                      border: "none",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.25s ease",
                      background: isdark === "light" ? "#185698" : (iscolourDark?.Colour10 || "#3b82f6"),
                      color: isdark === "light" ? (iscolour?.Colour1 || "#fff") : (iscolourDark?.Colour3 || "#fff"),
                      padding: "10px",
                      fontSize: "14px",
                      borderRadius: "12px",
                      boxShadow: isdark === 'light' ? `0 4px 12px #18569840` : `0 4px 12px ${iscolourDark?.Colour10 || "#3b82f6"}40`
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.filter = "brightness(1.1)";
                      e.currentTarget.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.filter = "none";
                      e.currentTarget.style.transform = "none";
                    }}
                  >
                    Apply Filter
                  </button>
                </div>
              )}
            </div>
          </Col>

          {/* Right Section */}
          <Col xs="auto" className="order-3 ms-auto justify-content-end d-flex p-0 flex-shrink-0" >
            <div style={{ display: "flex", alignItems: "center" }}>

              <div className="pe-2 d-none d-lg-block">
                <div
                  style={{
                    background: isdark === "light"
                      ? `#18569815`
                      : `${iscolourDark?.Colour10 || "#3b82f6"}20`,
                    border: `1px solid ${isdark === "light"
                      ? `#18569830`
                      : `${iscolourDark?.Colour10 || "#3b82f6"}30`}`,
                    color: isdark === "light"
                      ? "#185698"
                      : "#E2E8F0",
                    padding: "0 15px",
                    borderRadius: "14px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "13.5px",
                    gap: "10px",
                    height: "38px"
                  }}
                >
                  {/* Date */}
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <Clock size={15} style={{ color: isdark === "light" ? "#64748b" : "#94a3b8" }} />
                    <span>
                      {formatDateTime(
                        JobExecDatas?.JobExecDate?.[0]?.StartTime
                      )}
                    </span>
                  </div>

                  {/* Refresh */}
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: isdark === "light"
                        ? `#18569820`
                        : `${iscolourDark?.Colour10 || "#3b82f6"}30`,
                      padding: "6px",
                      cursor: "pointer",
                      borderRadius: "8px",
                      color: isdark === "light"
                        ? "#185698"
                        : "#E2E8F0",
                      transition: "all 0.2s ease",
                      marginLeft: "4px"
                    }}
                    onClick={refresh}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = isdark === "light"
                        ? `#18569830`
                        : `${iscolourDark?.Colour10 || "#3b82f6"}40`;
                      e.currentTarget.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = isdark === "light"
                        ? `#18569820`
                        : `${iscolourDark?.Colour10 || "#3b82f6"}30`;
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  >
                    {JobLoading ? (
                      <ClipLoader size={16} color={isdark === "light" ? "#0F172A" : "#E2E8F0"} />
                    ) : (
                      <IoMdRefresh size={16} />
                    )}
                  </span>
                </div>
              </div>


              <div
                className={`theme-toggle ${isdark === "dark" ? "darkmode" : ""}`}
                onClick={() => changeTheme(isdark === "light" ? "dark" : "light")}
              >
                <div className="theme-toggle__indicator">
                  <div className="theme-toggle__icon-container">
                    {isdark === "light" ? (
                      <FaSun
                        className={`theme-toggle__icon ${isdark === "light" ? "rotate" : ""
                          }`}
                      />
                    ) : (
                      <FaMoon
                        className={`theme-toggle__icon ${isdark === "dark" ? "rotate" : ""
                          }`}
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* Profile Dropdown */}
              <div ref={profileDropdownRef} className="profile-dropdown-wrapper">
                <div
                  onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                  className={`profile-avatar-btn ${showProfileDropdown ? "active" : ""}`}
                  title="Profile"
                >
                  <div className="profile-avatar-gradient">
                    {(Cookies.get("OwnerName") || Cookies.get("SqlName") || "U").charAt(0).toUpperCase()}
                  </div>
                </div>

                {showProfileDropdown && (
                  <div className="profile-dropdown-panel">
                    <div className="profile-dropdown-header">
                      <div className="profile-dropdown-avatar-small">
                        {(Cookies.get("OwnerName") || Cookies.get("SqlName") || "U").charAt(0).toUpperCase()}
                      </div>
                      <div className="profile-dropdown-info">
                        <div className="profile-dropdown-name">
                          {Cookies.get("OwnerName") || Cookies.get("SqlName") || Cookies.get("SqlId") || "User"}
                        </div>
                        <div className="profile-dropdown-role">
                          {Cookies.get("Role") || "User"}
                        </div>
                      </div>
                    </div>

                    <div className="profile-dropdown-items">
                      <div
                        className="profile-dropdown-item"
                        onClick={() => {
                          setShowProfileDropdown(false);
                          window.dispatchEvent(new Event("openCustomMenuModal"));
                        }}
                      >
                        <Sliders size={16} />
                        <span>Customize My Menu</span>
                      </div>

                      <div
                        className="profile-dropdown-item logout-item"
                        onClick={() => {
                          setShowProfileDropdown(false);
                          setShowLogoutConfirm(true);
                        }}
                      >
                        <LogOut size={16} />
                        <span>Logout</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row >
      </div >

      {/* Logout Confirmation Modal */}
      <style>{`
        .logout-confirm-modal .modal-content {
          background-color: ${isdark === "light" ? "#ffffff" : "#0f172a"} !important;
          border: 1px solid ${isdark === "light" ? "#e2e8f0" : "#1e293b"} !important;
          border-radius: 16px !important;
          box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
        }
        .logout-confirm-modal .btn-close {
          filter: ${isdark === "dark" ? "invert(1) grayscale(1) brightness(2)" : "none"};
        }
      `}</style>
      <Modal
        show={showLogoutConfirm}
        onHide={() => setShowLogoutConfirm(false)}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="logout-confirm-modal"
      >
        <Modal.Header closeButton style={{ borderBottom: "none" }}>
          <Modal.Title style={{ fontWeight: "700", color: isdark === "light" ? "#1e293b" : "#f8fafc" }}>
            Confirm Logout
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "16px", padding: "10px 20px 20px 20px", color: isdark === "light" ? "#475569" : "#cbd5e1" }}>
          Are you sure you want to log out?
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "none", padding: "0 20px 20px 20px" }}>
          <Button
            variant="secondary"
            onClick={() => setShowLogoutConfirm(false)}
            style={{
              borderRadius: "10px",
              padding: "8px 20px",
              fontWeight: "600",
              background: isdark === "light" ? "#f1f5f9" : "#1e293b",
              color: isdark === "light" ? "#0f172a" : "#f8fafc",
              border: "none",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={logout}
            style={{
              borderRadius: "10px",
              padding: "8px 20px",
              fontWeight: "600",
              background: "#ef4444",
              border: "none",
            }}
          >
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Header;